// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rKzp","label":"styles_label__2uySN"};